import React from 'react';
import { Phone, Smartphone, ShieldCheck, Mail } from 'lucide-react';

const IndiaBoatsTopBar = () => {
  // Configured contact numbers exactly as requested
  const contactDirectory = [
    { 
      label: 'Booking Numbers', 
      number: '+91 8591993301', 
      link: 'tel:+918591993301', 
      isLandline: false 
    },
    { 
      label: '', 
      number: '9004013301', 
      link: 'tel:9004013301', 
      isLandline: false 
    },
    { 
      label: ' ', 
      number: '8591983301', 
      link: 'tel:8591983301', 
      isLandline: false 
    },
    { 
      label: ' ', 
      number: '02266958111', 
      link: 'tel:02266958111', 
      isLandline: true 
    }
  ];

  return (
    <div className="ibtb-wrapper">
      <div className="ibtb-container">
        
        {/* Left Side: Editable Mail Address */}
        <div className="ibtb-left">
          <Mail size={14} className="ibtb-mail-icon" />
          <a 
            href="mailto:info@indiaboats.in" 
            className="ibtb-mail-link"
            title="Email India Boats Support"
          >
            info@indiaboats.in
          </a>
        </div>

        {/* Right Side: Active Click-to-Call Contact List */}
        <div className="ibtb-right">
          <div className="ibtb-list">
            {contactDirectory.map((contact, index) => (
              <a 
                key={index} 
                href={contact.link} 
                className="ibtb-item"
                title={`Call India Boats - ${contact.label}`}
              >
                {/* Dynamically swap between Landline (Phone) and Smartphone (Mobile) icons */}
                {contact.isLandline ? (
                  <Phone size={12} className="ibtb-icon" />
                ) : (
                  <Smartphone size={12} className="ibtb-icon" />
                )}
                <div className="ibtb-meta-group">
                  <span className="ibtb-item-label">{contact.label}</span>
                  <span className="ibtb-item-val">{contact.number}</span>
                </div>
              </a>
            ))}
          </div>
        </div>

      </div>

      {}
      <style dangerouslySetInnerHTML={{ __html: `
        /* Premium Scoped Plain CSS with prefix 'ibtb-' */
        .ibtb-wrapper {
          background-color: #2b4569; /* Beautiful dark premium blue layer above main navbar */
          color: rgba(255, 255, 255, 0.85);
          
          font-size: 11px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.08);
          width: 100%;
          position: relative;
          z-index: 1000; /* Sits above sticky navbars */
        }

        .ibtb-container {
          
          margin: 0 auto;
          padding: 0 24px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 38px;
        }

        /* Left Section styling */
        .ibtb-left {
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .ibtb-mail-icon {
          color: #ffffff; /* Premium white icon */
          font-size: 14px;
        }

        .ibtb-mail-link {
          color: rgba(255, 255, 255, 0.85);
          text-decoration: none;
          font-weight: 500;
          transition: color 0.25s ease;
          font-size: 14px;
        }

        .ibtb-mail-link:hover {
          color: #ffffff;
        }

        /* Right Section/Call-List styling */
        .ibtb-right {
          display: flex;
          align-items: center;
          height: 100%;
        }

        .ibtb-list {
          display: flex;
          align-items: center;
          height: 100%;
        }

        .ibtb-item {
          display: flex;
          align-items: center;
          gap: 8px;
          color: rgba(255, 255, 255, 0.9);
          text-decoration: none;
          padding: 0 18px;
          border-right: 1px solid rgba(255, 255, 255, 0.12);
          transition: all 0.25s cubic-bezier(0.165, 0.84, 0.44, 1);
          height: 100%;
        }

        .ibtb-item:last-child {
          border-right: none;
          padding-right: 0;
        }

        .ibtb-icon {
          color: #ffffff; /* Changed to premium white */
          transition: transform 0.3s ease;
        }

        .ibtb-meta-group {
          display: flex;
          align-items: baseline;
          gap: 6px;
        }

        .ibtb-item-label {
          color: rgba(255, 255, 255, 0.8);
          font-weight: 500;
          font-size: 14px;
        }

        .ibtb-item-val {
          font-weight: 600;
          letter-spacing: 0.3px;
          font-size: 14px;
        }

        /* Micro-interactions */
        .ibtb-item:hover {
          background-color: rgba(255, 255, 255, 0.03);
          color: #ffffff;
        }

        .ibtb-item:hover .ibtb-icon {
          transform: translateY(-1px) scale(1.08);
        }

        /* Responsive Mobile Breakpoints */
        @media (max-width: 1024px) {
          .ibtb-item {
            padding: 0 12px;
          }
          .ibtb-item-label {
            display: none; /* Auto-hide desk sub-labels on medium tablets to prevent wrapping */
          }
        }

        @media (max-width: 768px) {
          .ibtb-container {
            flex-direction: column;
            height: auto;
            padding: 0;
          }

          .ibtb-left {
            display: none; /* Hide top support badge on small displays */
          }

          .ibtb-right {
            width: 100%;
          }

          /* Transition horizontal contacts to a beautiful, clean 2x2 grid */
          .ibtb-list {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-template-columns: repeat(2, 1fr);
            width: 100%;
          }

          .ibtb-item {
            display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    padding: 14px 12px;
    height: 100%;
    min-height: 56px;

    text-align: center;
    border-right: 1px solid rgba(255, 255, 255, 0.08);
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
          }

          .ibtb-item-label {
            display: inline-block; /* Re-enable labels inside the mobile grid cards */
          }

          .ibtb-meta-group {
            flex-direction: column;
            align-items: flex-start;
            gap: 1px;
          }

          .ibtb-item:nth-child(2n) {
            border-right: none; /* Remove right boundary for the second column */
          }

          /* Remove bottom border from last row (for exactly 4 items) */
  .ibtb-item:nth-last-child(-n + 2) {
    border-bottom: none;
  }

  .ibtb-item:last-child {
    padding-right: 12px; /* Override desktop */
  }

  .ibtb-item:nth-child(3n) {
    padding-left: 0;
    padding-right: 25px;
  }

   .ibtb-item:nth-child(4n){
   padding-left: 20px;
   }
        }
      `}} />
    </div>
  );
};

export default IndiaBoatsTopBar;